import { createSelector } from 'reselect';
const ALL_DAY_SHIFT = 'allday';

export const shiftsSelector = createSelector(
    [state => state.shift.get('records')],
    shifts => shifts.toJS()
);

export const shiftSelectorForHeader = createSelector(
    [state => state.shift.get('records')],
    shiftRecords => {
        const allDayIndex = shiftRecords.findIndex(
            shift => shift.get('shiftId') === ALL_DAY_SHIFT
        );
        let newShiftRecords = shiftRecords;
        if (allDayIndex > 0) {
            const allDayShift = shiftRecords.get(allDayIndex);
            newShiftRecords = shiftRecords
                .delete(allDayIndex)
                .insert(0, allDayShift);
        }
        return newShiftRecords.map(shift => {
            return {
                value: shift.get('shiftId'),
                label: shift.get('label')
            };
        });
    }
);
